import { render } from "./SwDatePickerField.vue?vue&type=template&id=42a65da4"
import script from "./SwDatePickerField.vue?vue&type=script&lang=js"
export * from "./SwDatePickerField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__